var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slots"},_vm._l((_vm.slots),function(slot){return _c('Slot',{key:slot.id,attrs:{"data":slot,"isSelectedLeft":slot.isSelectedLeft,"isSelectedRight":slot.isSelectedRight}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }